/**
 * Facets used for tracking demand and resolution of items.
 */

import { Facet, IFaceted } from '../models/Facet';

/**
 * @public
 */
export const errorFacet: Facet<Error> = new Facet('error');

/**
 * @internal
 */
export const enum DemandResolution {
  unresolved = '',
  resolved = 'resolved',
  failed = 'failed',
  unhandled = 'unhandled',
  unsupported = 'unsupported'
}

/**
 * Facet which indicates the resolution state of other facets on an item.
 * @internal
 */
export const resolvedFacet: Facet<{
  /**
   * Reflects the current demands, by facet, met by the item.
   */
  demands: IFaceted<DemandResolution>; // TODO Make this be 'truthy' only.
}> = new Facet('resolved');

/**
 * Facet which indicates which other facets on other items must be invalidated
 * in response to updates to facets on the current item.
 * @public
 */
export const invalidationFacet: Facet<{
  triggers: IFaceted<{
    targets: {
      [itemKey: string]: IFaceted<boolean>;
    };
  }>;
}> = new Facet('invalidation');
